import dayjs, { Dayjs } from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';

interface CommonDatePickerProps {
  selectedDate: string | null | Dayjs;
  setSelectedDate: (date: string | null) => void;
}

export default function CommonDatePicker({ selectedDate, setSelectedDate }: CommonDatePickerProps) {
  const parsedValue =
    typeof selectedDate === 'string' && selectedDate
      ? dayjs(selectedDate.replace(/\./g, '-'))
      : selectedDate && typeof selectedDate !== 'string'
        ? selectedDate
        : null;

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DateCalendar
        value={parsedValue && parsedValue.isValid() ? parsedValue : null}
        onChange={(newValue: Dayjs | null) => {
          if (newValue && newValue.isValid()) {
            setSelectedDate(newValue.format('YYYY-MM-DD'));
          } else {
            setSelectedDate(null);
          }
        }}
      />
    </LocalizationProvider>
  );
}
